
<!-- https://stackblitz.com/edit/textarea-formly?file=src%2Fapp%2Fcustom-input.component.ts -->
<!-- <mat-form-field class="form-element">
    <textarea matInput [name]="'key'" placeholder="to.label"
    cdkTextareaAutosize #autosize="cdkTextareaAutosize"
    [formControl]="$any(form.get('formControl'))" [cols]="to.cols"
    [rows]="to.rows" [formlyAttributes]="field"
    disabled="to.disabled" (change)="valueChangeFn(field.key, field.id, $event)">
    </textarea>
</mat-form-field> -->

<mat-form-field class="form-element">
    <textarea matInput  placeholder="{{to.label}}"
    cdkTextareaAutosize #autosize="cdkTextareaAutosize"
    [formControl]="formControl" [cols]="to.cols"
    [rows]="to.rows" [formlyAttributes]="field"
    disabled="to.disabled" (change)="valueChangeFn(field.key, field.id, $event)">
    </textarea>
</mat-form-field>